import type { VariantId } from '@atlassian/edition-benefits-modal/types';

import type { Product } from '../../../types';

interface UseVariantIdProps {
	currentRoute?: 'ops';
	isStorageLimitBreached?: boolean;
	product: Product;
}

export const useVariantId = ({
	product,
	currentRoute,
	isStorageLimitBreached,
}: UseVariantIdProps): VariantId => {
	if (currentRoute === 'ops') {
		return 'standard-rovo-service-agents-ops-team';
	}

	// When storage limit is breached, show storage-specific variants
	if (isStorageLimitBreached) {
		switch (product) {
			case 'jira-customer-service':
				return 'standard-storage-limits-csm-teams';
			case 'jira-service-management':
				return 'standard-storage-limits-jsm-teams';
			default:
				return 'standard-storage-limits-jsm-teams';
		}
	}

	switch (product) {
		case 'jira-customer-service':
			return 'standard-rovo-service-agents-csm-teams';
		case 'jira-service-management':
			return 'standard-rovo-service-agents-service-teams';
		default:
			return 'standard-rovo-service-agents-service-teams';
	}
};
